/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SasToken } from './SasToken';
import {
    SasTokenFromJSON,
    SasTokenFromJSONTyped,
    SasTokenToJSON,
} from './SasToken';

/**
 * 
 * @export
 * @interface GetSasTokenForDoctor
 */
export interface GetSasTokenForDoctor {
    /**
     * 
     * @type {boolean}
     * @memberof GetSasTokenForDoctor
     */
    status: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetSasTokenForDoctor
     */
    statusCode: number;
    /**
     * 
     * @type {string}
     * @memberof GetSasTokenForDoctor
     */
    errorMessage?: string;
    /**
     * 
     * @type {SasToken}
     * @memberof GetSasTokenForDoctor
     */
    data?: SasToken;
}

/**
 * Check if a given object implements the GetSasTokenForDoctor interface.
 */
export function instanceOfGetSasTokenForDoctor(value: object): boolean {
    if (!('status' in value)) return false;
    if (!('statusCode' in value)) return false;
    return true;
}

export function GetSasTokenForDoctorFromJSON(json: any): GetSasTokenForDoctor {
    return GetSasTokenForDoctorFromJSONTyped(json, false);
}

export function GetSasTokenForDoctorFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSasTokenForDoctor {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'statusCode': json['status_code'],
        'errorMessage': json['error_message'] == null ? undefined : json['error_message'],
        'data': json['data'] == null ? undefined : SasTokenFromJSON(json['data']),
    };
}

export function GetSasTokenForDoctorToJSON(value?: GetSasTokenForDoctor | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
        'status_code': value['statusCode'],
        'error_message': value['errorMessage'],
        'data': SasTokenToJSON(value['data']),
    };
}

